import {
  Button,
  Grid,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import CommonButton from "app/common/Component/Button/CommonButton";
import HandleKeydown from "app/common/HandleKeydown";
import { isAdmin, isRoleCashier } from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import React, { memo, useEffect, useState } from "react";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import { Form, Formik } from "formik";
import { Search } from "@material-ui/icons";
import FilterListIcon from "@material-ui/icons/FilterList";
import HistoryDepositList from "./HistoryDepositList";
const HistoryDepositIndex = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  let [isOpenFillter, setOpenFillter] = useState(true);

  const { resetStore, handleChangeFormSearch, searchHistoryDeposit } =
    useStore().feeStore.historyDepositStore;

  useEffect(() => {
    if (patientId) {
      handleChangeFormSearch({ patientId });
    }
    return () => resetStore();
  }, []);

  let isAdminPermission = isAdmin();
  let isRoleCashierPermission = isRoleCashier();
  return (
    <section className="mx-2 ">
      <Formik
        initialValues={searchHistoryDeposit}
        onSubmit={(values) => {
          handleChangeFormSearch({ ...values, patientId });
        }}
        enableReinitialize
      >
        <Form autoComplete="off">
          <Grid container component={"section"} spacing={1}>
            <Grid item xs={6} md={3}>
              <div className="w-50">
                <p
                  className="cards-header flex align-center item-form-header-custom gap-1"
                  style={{ fontSize: "16px" }}
                >
                  <span
                    className="flex items-center pointer"
                    style={{ fontWeight: "bold" }}
                  >
                    Danh sách lịch sử tiền cọc
                  </span>
                  <span
                    style={{ cursor: "pointer" }}
                    className="flex items-center"
                    onClick={() => setOpenFillter(!isOpenFillter)}
                  >
                    <FilterListIcon color="red" />
                  </span>
                </p>
              </div>
            </Grid>
            <Grid
              item
              xs={6}
              md={9}
              className="flex align-center justify-end"
            ></Grid>
            {!isOpenFillter && (
              <>
                <style>
                  {`
                      @keyframes slideDownFade {
                        0% {
                          opacity: 0;
                          transform: translateY(-10px);
                        }
                        100% {
                          opacity: 1;
                          transform: translateY(0);
                        }
                      }
                    `}
                </style>
                <div
                  style={{
                    animation: "slideDownFade 0.3s ease forwards",
                  }}
                >
                  <Grid container spacing={1} className="cards-body">
                    <Grid item xs={12} sm={4}>
                      <GlobitsDateTimePicker label="Từ ngày" name="fromDate" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <GlobitsDateTimePicker label="Đến ngày" name="toDate" />
                    </Grid>
                    <Grid item xs={12} sm={3} className="flex flex-end gap-2">
                      <Button className="btn-primary" type="submit">
                        <Search />
                        Tìm kiếm
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </>
            )}

            <Grid item xs={12}>
              <HistoryDepositList />
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </section>
  );
};

export default memo(observer(HistoryDepositIndex));
